import React from "react";
import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { CloseButton } from "@rentablo/components";
import { RecommendationLogo } from "@features/recommender/common";
import { getIdentifiers } from "../utils";
import { useRecommendationDetails } from "../RecommendationDetailsProvider";
import { HeaderContainer } from "./common";
import { PropsSection } from "./PropsSection";

type Props = {
  onClose?: () => void;
};

export const HeaderSection = ({ onClose }: Props) => {
  const isLessMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const { recommendation, imageUrl } = useRecommendationDetails();
  const fund = recommendation?.fund;
  const identifiersData = getIdentifiers(recommendation);

  return (
    <HeaderContainer>
      <Box
        display="flex"
        alignItems={isLessMd ? "flex-start" : "center"}
        justifyContent="space-between"
        flexDirection="row"
        mb={3}
        gap={3}
      >
        <Box
          display="flex"
          alignItems={isLessMd ? "flex-start" : "center"}
          flexDirection="column"
          gap={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <RecommendationLogo imageUrl={imageUrl} alt={fund?.name} />
            <Typography variant="body3">{fund?.name}</Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={2} minWidth="fit-content">
          {onClose && <CloseButton onClose={onClose} />}
        </Box>
      </Box>

      <PropsSection items={identifiersData} />
    </HeaderContainer>
  );
};
